import { CaretDownOutlined, DownOutlined, SmileOutlined } from '@ant-design/icons';
import { Col, Form, Input, Row, Select } from 'antd';
import React, { useState } from 'react'

const CompanyInfoForm = () => {
    const [disableTrueFalse, setDisableTrueFalse] = useState(true)
    const formItemLayout = {
        labelCol: {
            xs: {
                span: 24,
            },
            sm: {
                span: 8,
            },
        },
        wrapperCol: {
            xs: {
                span: 24,
            },
            sm: {
                span: 16,
            },
        },
    };
    const companyNames = [
        {
          value: "Limited Liability Corporation",
        },
        {
          value: "Aamir Khan (Eagle) - test1 - 912 n creek dr edmond, OK 73034",
        },
        {
          value: "Aspire Premier Properties - 5018 Quell Ct. Woodbridge, VA 22193",
        },
        {
          value: "Sitafa and Jevon Gill - 5018 Quell Court Woodbridge, VA 22193",
        },
      ];

const okNotOK =[
    {
        value: 'OK',
    },
    {
        value: "Not Ok"
    }
]
    return (
        <Col span={24}>
            <Form
                {...formItemLayout}
            >
                <Form.Item
                    name="Company Type"
                    label="Company Type"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your Company Type!',
                        },
                    ]}
                >
                    <Select disabled={disableTrueFalse} defaultValue='Limited Liability Corporation' options={companyNames}/>
                </Form.Item>
                <Form.Item
                    name="EIN"
                    label="EIN"
                    tooltip="EIN (Employer Identification Number) is the Tax ID on file for your company if you employ others. It can be found on 1099s, your EIN confirmation letter or other relevant forms and/or filings of your business."
                    rules={[
                        {
                            required: true,
                            message: 'Please input your EIN!',
                            whitespace: true,
                        },
                    ]}
                >
                    <Row>
                        <Col span={24}>
                            <Input disabled={disableTrueFalse} defaultValue='XX-XXXXXXX'/>
                        </Col>

                        <Col span={24}>
                            <p
                                style={{ fontWeight: "200", fontSize: "0.9em", lineHeight: 1.6 , color: 'gray'}}
                            >Please do not input an SSN. Only EINs will be registered successfully.</p></Col>
                    </Row>
                </Form.Item>
                <Form.Item
                    name="Confirm EIN"
                    label="Confirm EIN"
                    rules={[
                        {
                            required: true,
                            message: 'Please input again for Confirm EIN!',
                        },
                    ]}
                >
                    <Input disabled={disableTrueFalse} defaultValue='XX-XXXXXXX'/>
                </Form.Item>
                <Form.Item
                    name="Company Name"
                    label="Company Name"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your Company Name!',
                            whitespace: true,
                        },
                    ]}
                >
                    <Input disabled={disableTrueFalse} defaultValue='Integrity Oklahoma LLC'/>
                </Form.Item>
                <Form.Item
                    name="Street Address"
                    label="Street Address"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your Street Address!',
                            whitespace: true,
                        },
                    ]}
                >
                    <Input disabled={disableTrueFalse} defaultValue='1800 Canyon Park Circle, Suite 202'/>
                </Form.Item>
                <Form.Item
                    name="City"
                    label="City"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your City!',
                            whitespace: true,
                        },
                    ]}
                >
                    <Input disabled={disableTrueFalse} defaultValue='Edmond'/>
                </Form.Item>
                <Form.Item
                    name="State"
                    label="State"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your State!',
                            whitespace: true,
                        },
                    ]}
                >
                    <Select disabled={disableTrueFalse} defaultValue='OK' options={okNotOK}/>
                </Form.Item>
                <Form.Item
                    name="ZIP Code"
                    label="ZIP Code"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your ZIP Code!',
                            whitespace: true,
                        },
                    ]}
                >
                    <Input disabled={disableTrueFalse} defaultValue='73013'/>
                </Form.Item>
                <Form.Item
                    name="Company Website"
                    label="Company Website"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your Company Website!',
                            whitespace: true,
                        },
                    ]}
                >
                    <Input disabled={disableTrueFalse} defaultValue='http://IntegrityOklahoma.com'/>
                </Form.Item>
            </Form>
        </Col>
    )
}

export default CompanyInfoForm